module.exports = __webpack_public_path__ + "static/media/hoc.62afa440.svg";